import IETBHEC26_Sponsorship from '../assets/IETBHEC26_Sponsorship.pdf'

function SponsorshipExhibition() {
    return (
        <div>
            <h2>Sponsorship and Exhibition</h2>
            <p>IETBHEC’26 is the fifth conference in the IETEC series and will be held in vibrant, beautiful Singapore, 05 - 07 July 2026, IETBHEC’26 will provide opportunities for all stakeholders from around the globe to explore the education outcomes, issues, and strategies needed to meet todays and tomorrow’s challenges, particularly in engineering, technology, business and health education. </p>
            <p>A range of sponsorship opportunities are now available for the conference, offering valuable exposure to industry leaders, policy makers, educationalists and professionals. You can showcase your brand at IETBHEC’26, a popular gathering of educators from around the globe. </p>
            <table className="table table-bordered sponsor-table">
                <tbody>
                    <tr>
                        <td>Corporate Sponsor</td>
                        <td>SGD 10,000</td>
                    </tr>
                    <tr>
                        <td>Platinum Sponsor</td>
                        <td>SGD 8,000</td>
                    </tr>
                    <tr>
                        <td>Gold Sponsor</td>
                        <td>SGD 5,000</td>
                    </tr>
                    <tr>
                        <td>Silver Sponsor</td>
                        <td>SGD 3,000</td>
                    </tr>
                    <tr>
                        <td>Banquet/Dinner Sponsor</td>
                        <td>SGD 4,000</td>
                    </tr>
                    <tr>
                        <td>Exhibition Space</td>
                        <td>SGD 4,000</td>
                    </tr>
                </tbody>
            </table>
            <p>The IETBHEC’26 sponsorship can also be “unrestricted” contributions and/or ”in-kind” such as printing of conference materials, morning and afternoon tea breaks, lunches and dinners, sponsorship of Gala Banquet, transportation, or any other direct expenses related to the conference organization.</p>
            <p>Contact: <a href="mailto:contact@ietbhec.com" target='_blank' rel="noreferrer noopener">contact@ietbhec.com</a></p>
            <p>Sponsorship Detail: <a href={IETBHEC26_Sponsorship} target='_blank' rel="noreferrer noopener">IETBHEC26_Sponsorship.pdf</a></p>
        </div>
    )
}

export default SponsorshipExhibition